import { render, staticRenderFns } from "./JoinInfo.vue?vue&type=template&id=4cabdd5b&scoped=true&lang=pug&"
import script from "./JoinInfo.vue?vue&type=script&lang=js&"
export * from "./JoinInfo.vue?vue&type=script&lang=js&"
import style0 from "./JoinInfo.vue?vue&type=style&index=0&id=4cabdd5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cabdd5b",
  null
  
)

component.options.__file = "JoinInfo.vue"
export default component.exports